export default "__VITE_ASSET__oor0Iv2g__"